import history from "../History/History";

export const LogOut = function () {
  localStorage.clear();
  history.push("/");
  window.location.reload();
};
